import { PageSchema } from '@vs-shop/schemas/url/queryParams/pagination';
import { Effect, Option } from 'effect';

import { accessoriesPageParamName } from '@vs-shop/schemas/config/urlParams';

import { RuntimeClientAtom } from '@vs-shop/engine/runtime/RuntimeClient';
import { saveAccessoriesTaxonToHistoryState } from '../../utils/history/productAccessoriesHistoryStateManager';
import * as Atom from 'effect/unstable/reactivity/Atom';

export const accessoriesTaxonSearchParamAtom = Atom.make<Option.Option<string>>(Option.none());

export const accessoriesPageSearchParamAtom = Atom.searchParam(accessoriesPageParamName, {
  schema: PageSchema,
}).pipe(Atom.withServerValue(() => Option.none()));

export const currentAccessoriesPageAtom = Atom.map(accessoriesPageSearchParamAtom, (pageOption) =>
  Option.getOrElse(pageOption, () => 1)
).pipe(Atom.withServerValue(() => 1));

export const accessoriesLoadMorePagesAtom = Atom.make<number>(0);

export const changeAccessoriesTaxonAtomFn = RuntimeClientAtom.fn(
  Effect.fnUntraced(function* (
    params: { taxonCode: string | null; productCode: string },
    ctx: Atom.FnContext
  ) {
    const { taxonCode, productCode } = params;
    yield* Effect.logDebug('🔄 changeAccessoriesTaxonAtomFn', taxonCode);

    ctx.set(
      accessoriesTaxonSearchParamAtom,
      taxonCode === null ? Option.none() : Option.some(taxonCode)
    );
    ctx.set(accessoriesPageSearchParamAtom, Option.none());
    ctx.set(accessoriesLoadMorePagesAtom, 0);

    yield* Effect.sync(() => {
      saveAccessoriesTaxonToHistoryState(taxonCode, productCode);
    });
  })
);

export type ChangeAccessoriesPageAtomPromise = (
  value: number | typeof Atom.Reset | typeof Atom.Interrupt
) => Promise<void>;

export const changeAccessoriesPageAtomFn = RuntimeClientAtom.fn(
  Effect.fnUntraced(function* (page: number, ctx: Atom.FnContext) {
    yield* Effect.logDebug('🔄 changeAccessoriesPageAtomFn', page);

    ctx.set(accessoriesPageSearchParamAtom, page === 1 ? Option.none() : Option.some(page));
    ctx.set(accessoriesLoadMorePagesAtom, 0);
  })
);

export const recommendationsLastPageLoadedIncludingLoadMoreAtom = Atom.readable((ctx) => {
  const page = ctx.get(currentAccessoriesPageAtom);

  return page;
}).pipe(Atom.withServerValue(() => 1));
